import { Button } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import { ClientMigrations } from "slot-definitions"
import { ClientDataMigrationDialog } from "../../client-data-migration-dialog"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { migrationResultSnackbar } from "../../migration-result-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { getLegacyDraftCustomSchedules } from "./controller/get-legacy-draft-custom-schedules"
import { importLegacyDraftCustomSchedules } from "./controller/import-legacy-draft-custom-schedules"
import { invalidate } from "lib/graphql/cache"

const CUSTOM_DATA_MIGRATION_DRAFT_SCHEDULES = "draft custom schedules"

ClientMigrations.plug(<LegacyDraftCustomSchedules priority={300} />)

function LegacyDraftCustomSchedules() {
    const { subscriptionId } = useBoundContext()
    const dialog = useDialog(
        <ClientDataMigrationDialog
            type={CUSTOM_DATA_MIGRATION_DRAFT_SCHEDULES}
            subscriptionId={subscriptionId}
            getKey={(d) => d.customScheduleId}
            transform={(d) => ({ ...d, label: `${d.label} (#${d.code})` })}
            query={getLegacyDraftCustomSchedules}
            warning={"Only draft schedules will be migrated."}
        />,
        // A fixed height stops the dialog resizing and re-centring as the search narrows the list
        { maxWidth: "lg", sx: { height: { md: "85vh" } } }
    )

    return (
        <Button
            variant="outlined"
            size="large"
            onClick={handleMigrate}
            startIcon={<Iconify icon={"ion:documents-outline"} />}
        >
            Custom Schedules (Draft)
        </Button>
    )

    async function handleMigrate() {
        const data = await dialog()
        if (data && data.length > 0) {
            try {
                const selectedIds = data.map("customScheduleId")
                const result = await importLegacyDraftCustomSchedules(subscriptionId, selectedIds)
                invalidate("getLegacyDraftCustomSchedules")
                migrationResultSnackbar(result, "draft custom schedule")
            } catch (error) {
                errorSnackbar("Error migrating draft custom schedules")
            }
        }
    }
}
